<template>
  <div class="mb-5">
    <div>
      <div>
        <img
          :src="imageUrl(course.cover_photo)"
          alt=""
          class="img-fluid rounded-3 d-block mx-auto"
          style="max-height: 300px; object-fit: contain"
          loading="lazy"
        />
        <SlotPicker v-if="slots.length" v-model="chosenSlot" :slots="slots" :timezone="calendarTimezone" class="mt-4" />
      </div>
      <div class="d-flex align-items-start mt-4">
        <div class="fw-bold">
          {{ course.title }}
        </div>
        <div class="ms-auto text-nowrap">
          <div v-if="(course.is_free || course.allow_student_to_set_price) && !selectedOrderBumps">
            {{ course.finalPrice | price(page.currency) }}
          </div>
          <div v-else-if="course.is_free && selectedOrderBumps">
            {{ 0 | price(page.currency) }}
          </div>
          <div v-else-if="course.price_variants">
            {{ course.subtotal | price(page.currency) }}
          </div>
          <div v-else>
            <del v-if="priceDiff">{{ course.price | price(page.currency) }}</del>
            <span v-else class="fw-bold">
              {{ course.price | price(page.currency) }}
            </span>
          </div>
        </div>
      </div>
      <div v-if="course.checkout_description" class="markdown mt-3" v-html="snark(course.checkout_description)"></div>
      <OrderBumps></OrderBumps>
      <MultipleLicences v-if="course.multiple_licences || course.type === 'physical'"></MultipleLicences>
      <div v-show="showPromoCodeField">
        <PromoCode class="mb-3"></PromoCode>
      </div>
      <div class="d-flex justify-content-between small mb-3" v-if="course.type === 'physical'">
        <div>
          {{ 'Shipping cost' | translate }}
        </div>
        <div>
          {{ chosenShippingTypeCost | price(page.currency) }}
        </div>
      </div>
      <div class="mt-3" v-if="priceDiff">
        <div class="d-flex align-items-center">
          <div>
            {{ 'Discount' | translate }}
          </div>
          <div class="ms-auto text-success fw-bold">
            {{ priceDiff | price(page.currency) }}
          </div>
        </div>
      </div>
      <hr />
      <div class="d-flex align-items-end">
        <div class="fw-bold">
          {{ 'Total' | translate }}
        </div>
        <div class="ms-auto h4 fw-bold mb-0">
          {{ course.finalPrice | price(page.currency) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import PromoCode from './../PromoCode'
import MultipleLicences from './MultipleLicences'
import OrderBumps from './OrderBumps'
import snarkdown from 'snarkdown'
import SlotPicker from './SlotPicker.vue'

export default {
  components: {
    PromoCode,
    MultipleLicences,
    OrderBumps,
    SlotPicker,
  },
  filters: {
    price(value, currency) {
      return (value / 100).toLocaleString(document.documentElement.lang, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
      })
    },
  },
  computed: {
    slots() {
      return this.$store.state.slots
    },
    calendarTimezone() {
      return this.$store.state.calendarTimezone
    },
    chosenSlot: {
      get() {
        return this.$store.state.selectedSlot
      },
      set(slot) {
        this.$store.commit('setSelectedSlot', slot)
      },
    },
    chosenShippingTypeCost() {
      return this.$store.state.shippingCost[this.$store.state.shippingData.shipmentType] || 0
    },
    selectedOrderBumps() {
      return this.$store.state.selectedOrderBumps.length
    },
    quantity() {
      return this.$store.state.quantity || 1
    },
    pricePerLicence() {
      return this.course.finalPrice / this.quantity
    },
    showPromoCodeField() {
      if (this.course.multiple_licences || this.course.is_free || this.course.allow_student_to_set_price) {
        return false
      }
      let view = this.$store.state.view
      if (this.checkoutType === 'membership' && this.$store.state.page.payment_provider === 'Stripe') {
        return false
      }
      if (this.student.email) {
        return this.$store.state.page.display_promo_code_field
      }
      if (view === 'register') {
        return this.$store.state.page.display_promo_code_field
      }
      return false
    },
    checkoutType() {
      return this.$store.state.checkoutType
    },
    student() {
      return this.$store.state.user
    },
    priceDiff() {
      let diff = this.course.finalPrice - this.course.subtotal
      if (diff < 0) {
        return diff
      }
      return 0
    },
    course() {
      return this.$store.getters.courseAfterPriceReductions
    },
    page() {
      return this.$store.state.page
    },
  },
  methods: {
    snark(text) {
      return snarkdown(text)
    },
    imageUrl(url) {
      if (url) {
        return `https://djceg34j53tq.cloudfront.net/${url}`
      }
      return 'https://placehold.co/1280x800/E1D4F1/ffffff'
    },
  },
}
</script>
